module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "content-chapter",
    attrs: {
      "id": "toc_marker-1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "Front-title-page-title"
  }, [_vm._v("THE "), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("HIGHWAY")]), _vm._v(" "), _c('p', {
    staticClass: "Front-title-page-subtitle"
  }), _vm._v(" "), _c('p', {
    staticClass: "Front-title-page-subtitle"
  }, [_vm._v("The Reanimates")]), _vm._v(" "), _c('p', {
    staticClass: "Front-title-page-subtitle"
  }, [_vm._v("BOOK 2")]), _vm._v(" "), _c('p', {
    staticClass: "Front-title-page-subtitle"
  }), _vm._v(" "), _c('p', {
    staticClass: "Front-title-page-author-name"
  }, [_vm._v("J. Rudolph")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-486aac0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/highway-1.vue
// module id = 60
// module chunks = 0